import { Component, inject } from '@angular/core';
import { KpiWidgetComponent } from "../../../../../../_shared/components/kpi-widget/kpi-widget.component";
import { BaseWidgetComponent } from '../../../../../../home/home-widgets/widgets/base-widget.component';
import { AuthService, FilterService } from '../../../../../../_shared/services';
import { ErrorHandlerService } from '../../../../../../_shared/services/error-handler.service';
import { PartsAndInventoryService } from '../../../services/parts-and-inventory.service';
import { PartsKpiRequest } from '../../../models/parts-kpi.model';
import { formatValue } from '../../../../../../_shared/helpers/kpiWidget/kpi-formatters.helper';
import { CurrencyHelper } from '../../../../../../_shared/helpers/currency/currency-map.helper';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-inventory-value-widget',
  standalone: true,
  imports: [KpiWidgetComponent],
  templateUrl: './inventory-value-widget.component.html',
  styleUrl: './inventory-value-widget.component.scss'
})
export class InventoryValueWidgetComponent extends BaseWidgetComponent {
  private partsAndInventoryService = inject(PartsAndInventoryService);
  private errorService = inject(ErrorHandlerService);
  private authService = inject(AuthService);
  private transloco = inject(TranslocoService);

  public errorMessage: string = '';
  public hasError: boolean = false;

  override title = this.transloco.translate('parts.widgets.inventoryValue');

  constructor() {
    super(inject(FilterService));
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    await this.loadInventoryValue();
  }

  private async loadInventoryValue(): Promise<void> {
    this.isLoading = true;
    this.hasError = false;
    this.errorMessage = '';

    const request: PartsKpiRequest = {
      accountIds: this.widgetFilter.accountIds
    };

    try {
      this.cancelSubject.next();
      const response = await this.partsAndInventoryService.getInventoryValueAsync(request);

      this.value = response.data?.totalValue ?? 0;
    } catch (error) {
      this.errorService.handleError(error);
    } finally {
      this.isLoading = false;
    }
  }

  public override formatValue(value: number): string {
    return formatValue(value, {
      currencySymbol: CurrencyHelper.getCurrencySymbol(
        this.authService.getUserSettings()?.currencyCode ?? 'ZAR'
      )
    });
  }

  public openInventoryValueModal(): void {
  }
}